import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import { internal_cloneResource } from '../../resource/resource.internal.mjs';
import 'n3';
import '../../rdfjs.mjs';
import { setThing } from '../../thing/thing.mjs';
import 'cross-fetch';
import 'uuid';

//
/** @hidden */
function setAccessControlResourceThing(resource, thing) {
    return Object.assign(internal_cloneResource(resource), {
        internal_acp: {
            ...resource.internal_acp,
            acr: setThing(resource.internal_acp.acr, thing),
        },
    });
}

export { setAccessControlResourceThing };
